<template>
	<div class="modal dm-modal" id="dm-default-modal" tabindex="-1" role="dialog" aria-labelledby="dm-default-modal-title" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered" role="document" v-bind:class="modalSize">
			<div class="modal-content">
				<div class="modal-header"
					v-if="title">
					<h2 class="modal-title w-100 h4" id="dm-default-modal-title">{{ title }}</h2>

					<div class="dm-close-modal d-flex align-items-center">
						<button type="button" class="dm-svg-button dm-transparent dm-dark" data-bs-dismiss="modal" aria-label="Close"
							v-if="! hide_close_btn" title="Close">
							<svg-icon icon="close" />
						</button>
					</div>
				</div>

				<div class="modal-body">
					<slot></slot>
				</div>

			</div>
		</div>
	</div>
</template>

<script>

export default {

    props: ['title', 'size', 'hide_close_btn'],

    computed: {
        modalSize() {
            if ( this.size == 'lg' ) return 'modal-lg';
            if ( this.size == 'md' ) return 'modal-md';
            if ( this.size == 'sm' ) return 'modal-sm';

            return 'modal-md';
        }
    }
}
</script>
